import React, { FC } from 'react';
import { IconEnum } from '@investoro/core';

import AutocompleteInput from 'components/common/Inputs/AutocompleteInput/AutocompleteInput';

export interface CalculatorOption {
    calculationId: number;
    name: string;
}

interface AutocompleteCalculatorInputProps {
    calculationId: number | null;
    options: CalculatorOption[];
    handleDeleteCalculation: (id: number) => void;
    handleSetCalculationValues: (id: number) => void;
}

const AutocompleteCalculatorInput: FC<AutocompleteCalculatorInputProps> = ({
    calculationId,
    options,
    handleDeleteCalculation,
    handleSetCalculationValues
}) => {
    return (
        <AutocompleteInput
            noTyping
            readOnly
            optionsIcon={IconEnum.BOOKMARK}
            value={calculationId}
            onChange={(id) => handleSetCalculationValues(id as number)}
            placeholder="Wybierz kalkulację..."
            handleDeleteFilter={(id) => handleDeleteCalculation(id as number)}
            options={options.map((x) => ({
                label: x.name,
                value: x.calculationId,
                trash: true
            }))}
        />
    );
};

export default AutocompleteCalculatorInput;
